import React from 'react';
import { TermsConditionsWrapper, TermsContent, Header } from './PromotionTermsAndConditions.style';
import { CloseButton } from 'src/domains/players/webview/components/Account/promoSidebar/PromoSidebar.style';
import { PromoSidebarList } from 'src/domains/players/webview/components/Account/promoSidebar/PromoSidebarPartials/PromoSidebarPartials.style';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

export const PromotionTermsAndConditions = observer('PromotionTermsAndConditions', () => {
    const common = useCommon();

    const starRouter = StarRouter.get(common);
    const appPlayersState = AppPlayersState.get(common);

    const promotionSlug = starRouter.freeParams.promo ?? 'homepage';
    const promoLandingPage = appPlayersState.specialEvents.getLandingPageState(promotionSlug).promoLandingPage;
    const value = promoLandingPage.type === 'ready' ? promoLandingPage.value : null;
    return promoLandingPage.type === 'ready' ? (
        <TermsConditionsWrapper>
            <TermsContent>
                {value?.tc_text === undefined ? null : (
                    <PromoSidebarList dangerouslySetInnerHTML={{ __html: value.tc_text }} />
                )}
            </TermsContent>
        </TermsConditionsWrapper>
    ) : null;
});

export const PromotionTermsAndConditionsHeader = observer('PromotionTermsAndConditionsHeader', () => {
    const common = useCommon();
    const appPlayersState = AppPlayersState.get(common);
    const { specialEvents } = appPlayersState;

    return (
        <Header>
            Terms & Condition
            <CloseButton onClick={specialEvents.closePromoTermsConditions} />
        </Header>
    );
});
